var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Block',{attrs:{"spacingBottom":'0',"spacingTop":'0',"spacing":'0',"background":'transparent',"hasContainer":true}},[_c('Button',{attrs:{"clickFunction":_vm.loadMore,"text":_vm.translations.loadMoreButton,"variant":'secondary'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }